import React, { useEffect, useState } from 'react';
import TabsHeader from '../../components/TabsHeader/TabsHeader';
import { useSearchParams } from 'react-router-dom';
import AuditLogs from 'pages/Admin/AuditLogs';
import MembersTab from 'pages/Admin/Components/MembersTab';
import { usePerms } from 'contexts/PermsContext';
import { getVisibleUsers } from 'utils/roleUtils';
import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import { Container } from 'react-bootstrap';
import { getOrgName, getWorkplaceMembers } from 'services/organization/organization.service';
import { getAllRoles } from 'services/roles/roles.service';
export default function Organization() {
  const [params, setParams] = useSearchParams();
  const perms = usePerms();

  const [tabs, setTabs] = useState([0]);
  const [roleList, setRoleList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [orgName, setOrgName] = useState('');
  const [editOrgName, setEditOrgName] = useState(false);

  useEffect(() => {
    setTabs(params.get('tab') ? [parseInt(params.get('tab'))] : [0]);

    (async () => {
      await getAllRoles().then((res) => {
        setRoleList([...res.data.result]);
      });

      await getOrgName().then((res) => {
        setOrgName(res.data.result.work_place_name);
      });

      await getWorkplaceMembers(getVisibleUsers(perms)).then((res) => {
        setMemberList([...res.data.result]);
      });
    })();
  }, []);

  //components go in here to display data
  const renderTab = () => {
    switch (params.get('tab')?.toLowerCase()) {
      case 'users':
        return (
          <MembersTab
            list={memberList}
            setMemberList={setMemberList}
            mousePosition={mousePosition}
            perms={perms}
            setMousePosition={setMousePosition}
            roleList={roleList}
            listOnly
            editableOrgName
          />
        );
      case 'audit logs':
        return <AuditLogs />;
      default:
        return (
          <MembersTab
            list={memberList}
            setMemberList={setMemberList}
            mousePosition={mousePosition}
            perms={perms}
            setMousePosition={setMousePosition}
            roleList={roleList}
            listOnly
            editableOrgName
          />
        );
    }
  };

  return (
    <Container fluid className="d-flex flex-column h-100 w-100 pb-3">
      {/* header */}
      <div className="w-100 d-none d-lg-block">
        <TabsHeader
          onTabChange={(newTabArr) => setTabs([...newTabArr])}
          currentTabs={tabs}
          options={[{ option: 'Users' }, { option: 'Audit Logs' }]}
          styles={[{ backgroundColor: '#436c98' }]}
        />
      </div>
      <div className="w-100 d-block d-lg-none">
        <MobileTabsHeader options={[{ option: 'Users' }, { option: 'Audit Logs' }]} />
      </div>
      {/* content */}
      <div className="flex-grow-1 min-h-0 overflow-hidden">{renderTab()}</div>
    </Container>
  );
}
